import { tryCatch } from '@wix/funnel-utils';
import React, { useEffect, useState } from 'react';
import { useWixFlowContext } from '../WixFlow/WixFlowContext';
import { TemplatesContext } from './TemplatesContext';
export const Templates = _ref => {
  let {
    Loader,
    pageId,
    forcePage,
    forceLanguage,
    debugTranslationKeys,
    children
  } = _ref;
  const {
    flowContext,
    service,
    showFallback
  } = useWixFlowContext();
  const [page, setPage] = useState(null);
  const [isPageLoading, setIsPageLoading] = useState(true);
  useEffect(() => {
    const getPageContent = async () => {
      const [error, page] = await tryCatch(() => forcePage ?? service.getPageContent({
        flowContext,
        pageId,
        forceLanguage,
        debugTranslationKeys
      }));
      if (error) {
        showFallback();
      } else {
        setPage(page);
        setIsPageLoading(false);
      }
    };
    void getPageContent();
  }, [flowContext, service, pageId, forcePage, forceLanguage, debugTranslationKeys, showFallback]);
  if (!page) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  const value = {
    activePage: page,
    setIsPageLoading: pageId ? () => {} : setIsPageLoading,
    isPageLoading
  };
  return /*#__PURE__*/React.createElement(TemplatesContext.Provider, {
    value: value
  }, children);
};
//# sourceMappingURL=Templates.js.map